import { getIconForTitle } from "@/features/marketing-content/utils/icon-map";

import type { PainPoint } from "@/content/alternatives/schema";

interface PainPointsGridProps {
  heading: string;
  description: string;
  painPoints: PainPoint[];
}

export function PainPointsGrid({ heading, description, painPoints }: PainPointsGridProps) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-clash text-3xl font-medium leading-tight tracking-snug text-ash-900 md:text-5xl">
            {heading}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ash-500">{description}</p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {painPoints.map((point) => {
            const Icon = getIconForTitle(point.title);
            return (
              <div key={point.title} className="rounded-2xl border border-ash-200 bg-ash-100/50 p-6">
                <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-rebolt-500/10">
                  <Icon className="size-5 text-rebolt-500" />
                </div>
                <h3 className="font-clash text-lg font-medium text-ash-900">{point.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ash-500">{point.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
